export const LOADING_JOB_FUNCTION = "LOADING_JOB_FUNCTION";
export const SAVE_LOADING_JOB_FUNCTION = "SAVE_LOADING_JOB_FUNCTION";
export const GET_JOB_FUNCTION = "GET_JOB_FUNCTION";
export const FORM_FAIL_JOB_FUNCTION = "FORM_FAIL_JOB_FUNCTION";
export const JOB_FUNCTION_FAIL = "JOB_FUNCTION_FAIL";
export const LOADING_JOB_FUNCTION_BY_ID = "LOADING_JOB_FUNCTION_BY_ID";
export const GET_JOB_FUNCTION_BY_ID = "GET_JOB_FUNCTION_BY_ID";

